import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/Views/Home.vue'
import Info from '@/Views/Info.vue'
Vue.use(VueRouter)



const routes = [
  {
    path:'/',
    name:'Info',
    component:Info
  },
  {
    path:'/home',
    name:'Home',
    component:Home
  },
]

const router = new VueRouter({
  routes
})


export default router
